import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';
import { Checkbox } from '@telus-uds/components-web';

import Label from './common/label';
import request from '../../../../../utils/request';

const MultiProvince = ({
  fieldData,
  setFieldData,
  formErrors,
  setFormErrors
}) => {
  const [provinceList, setProvinceList] = useState([]);
  const fieldError = 'provinces' in formErrors;

  const handleProvinceSelect = ({ target: { value } }) => {
    let selectedProvinces = [...fieldData.provinces];
    if (selectedProvinces.includes(value))
      selectedProvinces = _.pull(selectedProvinces, value);
    else selectedProvinces.push(value);

    if (selectedProvinces.length === 0) {
      setFormErrors(previousValue => ({
        ...previousValue,
        provinces: { message: 'Field is required' }
      }));
    } else {
      setFormErrors(previousValue => {
        const newValue = { ...previousValue };
        delete newValue.provinces;
        return newValue;
      });
    }

    setFieldData(previousValue => ({
      ...previousValue,
      provinces: selectedProvinces
    }));
  };

  useEffect(() => {
    request.get('/provinces').then(({ data: { provinces } }) => {
      setProvinceList(provinces);
    });
  }, []);

  return (
    <div>
      <Label labelName="Provinces *" />
      {fieldError && (
        <div className="error-notification">
          <p>{formErrors.provinces.message}</p>
        </div>
      )}
      <div
        style={{ position: 'relative', width: '100%', marginBottom: '-1rem' }}
        className="frg-select-container color-light input-container"
      >
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            rowGap: '0.5rem'
          }}
        >
          {provinceList &&
            provinceList.length > 0 &&
            provinceList.map(province => (
              <Checkbox
                key={province.name}
                id={`province-${province.name}`}
                checked={fieldData.provinces.includes(province.name)}
                onChange={() => handleProvinceSelect({ target: { value: province.name } })}
                name="provinces"
                value={province.name}
                label={province.name}
              />
            ))}
        </div>
      </div>
    </div>
  );
};

MultiProvince.propTypes = {
  formErrors: PropTypes.shape({
    provinces: PropTypes.shape({
      message: PropTypes.string
    })
  }).isRequired,
  setFormErrors: PropTypes.func.isRequired,
  setFieldData: PropTypes.func.isRequired,
  fieldData: PropTypes.shape({
    role: PropTypes.number,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    contactNumber: PropTypes.string,
    provinces: PropTypes.arrayOf(PropTypes.string),
    channels: PropTypes.arrayOf(PropTypes.string),
    outlet: PropTypes.string,
    cpmsId: PropTypes.string,
    xid: PropTypes.string,
    storeCode: PropTypes.string,
    dealership: PropTypes.arrayOf(PropTypes.string),
    channelOrgCode: PropTypes.string,
    salesManager: PropTypes.string,
    salesManagerEmail: PropTypes.string
  }).isRequired
};

export default MultiProvince;
